import { Text, type TextProps } from '@chakra-ui/react'

export default function Dot({ ...props }: TextProps) {
  return (
    <Text variant="eyebrow-small" color="fg.muted" {...props}>
      •
    </Text>
  )
}
